/* eslint-disable no-unused-vars */
/* eslint-disable no-undef eslint-disable-next-line no-unused-vars */
<template>
  <v-container
    class="pt-0 mt-0 pb-0 mb-0 no-gutters fluid"
    fluid
  >
    <v-row
      class="pt-0 mt-0 pb-0 mb-0 no-gutters fluid"
    >
      <v-col
        cols="12"
      >
        <grid
          :data-source="deviceItems"
          :selectable="'row'"
          :sortable="true"
          :filterable-mode="'row'"
          :groupable="false"
          :height="230"
          @change="onChange"
        >
          <kendo-grid-column
            :field="'idGeraet'"
            :title="'Id'"
            :width="100"
            :hidden="true"
            :filterable-cell-operator="'contains'"
            :filterable-cell-show-operators="false"
          />
          <kendo-grid-column
            :field="'nameGeraet'"
            :title="'Fahrzeug-Name'"
            :width="240"
            :filterable-cell-operator="'contains'"
            :filterable-cell-show-operators="false"
          />
          <kendo-grid-column
            :field="'telNrGeraet'"
            :title="'Fahrzeug-Tel.-Nr'"
            :width="240"
            :filterable-cell-operator="'contains'"
            :filterable-cell-show-operators="false"
          />
          <kendo-grid-column
            :field="'hinweis'"
            :title="'Fahrzeug-Hinweis'"
            :filterable-cell-operator="'contains'"
            :filterable-cell-show-operators="false"
          />
        </grid>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="3"
      >
        <h5 class="font-weight-light">
          Dokument-Inhalt:
        </h5>
      </v-col>
      <v-col
        class="no-gutters"
        cols="2"
      >
        <v-checkbox
          v-model="printGrafic"
          class="checkbox-align"
          label="Karte mit Route"
        />
      </v-col>
      <v-col
        class="no-gutters"
        cols="3"
      >
        <v-checkbox
          v-model="printTable"
          class="checkbox-align"
          label="Tabelle mit Tracking Punkten"
        />
      </v-col>
      <v-col
        class="px-14"
        cols="3"
      >
        <v-spacer />
        <v-btn
          @click="snapshot"
        >
          Dokument erzeugen
        </v-btn>
      </v-col>
    </v-row>

    <v-row
      class="pt-1 mt-1 pb-1 mb-1 no-gutters"
    >
      <v-col
        cols="12"
      >
        <div class="here-map">
          <div
            ref="map"
            :style="{ width: '100%', height: '835px' , visibility: visible ? 'visible' : 'hidden'}"
          />
        </div>
        <div
          id="panel"
          class="capture-panel"
          style="display:none"
        />
      </v-col>
    </v-row>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-overlay :value="info">
      <h5>
        <p>{{ infoMessage }}</p>
        <p>
          <v-btn
            color="warning"
            @click="info = false"
          >
            Ok
          </v-btn>
        </p>
      </h5>
    </v-overlay>
    <v-overlay :value="fault">
      <h5>
        <p>{{ faultMessage }}</p>
      </h5>
      <p>
        <v-btn
          color="error"
          @click="fault = false"
        >
          ok
        </v-btn>
      </p>
    </v-overlay>
  </v-container>
</template>
<script>
  import { Grid } from '@progress/kendo-grid-vue-wrapper'
  import client from './../../../../shared/apicllient/AuthenticatedClient'
  import svg from '../../../../shared/helper/Svg'

  export default {
    components: {
      Grid,
    },
    data () {
      return {
        deviceItems: [],
        vonDateString: this.$route.query.von,
        bisDateString: this.$route.query.bis,
        diffInMeters: this.$route.query.diffInMeters,
        timestamp: '',
        id: 0,
        // --> Here Map
        visible: false,
        map: {},
        ui: {},
        group: {},
        platform: {},
        coordinateItems: [],
        coords: {},
        lat: '47.2',
        lng: '8.2',
        printTable: true,
        printGrafic: true,
        overlay: false,
        info: false,
        infoMessage: '',
        fault: false,
        faultMessage: '',
      }
    },
    watch: {
      '$route' (to, from) {
        this.overlay = false
        this.vonDateString = to.query.von
        this.bisDateString = to.query.bis
        this.diffInMeters = to.query.diffInMeters
        this.getDevices()
      },
    },
    created () {
      this.visible = true
      this.getDevices()
    },
    mounted () {
      this.visible = true
      // eslint-disable-next-line no-undef
      this.platform = new H.service.Platform({
        app_id: 'XGHGefYx3urmCM8ed8At',
        app_code: 'YI50bnq08ERd2T3xrSKyWw',
        useCIT: false,
        useHTTPS: true,
      })

      const defaultLayers = this.platform.createDefaultLayers()

      // eslint-disable-next-line no-undef
      this.map = new H.Map(
        this.$refs.map,
        defaultLayers.normal.map,
        {
          zoom: 8.5,
          center: { lng: this.lng, lat: this.lat },
          disableDefaultUI: false,
        })

      // eslint-disable-next-line no-undef
      const behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map))
      console.log(behavior)
      // eslint-disable-next-line no-undef
      const ui = H.ui.UI.createDefault(this.map, defaultLayers, 'de-DE')
      console.log(this.ui)
      ui.getControl('zoom').setVisibility(true)
      var mapSettings = ui.getControl('mapsettings')
      var zoom = ui.getControl('zoom')
      var scalebar = ui.getControl('scalebar')

      mapSettings.setAlignment('bottom-left')
      zoom.setAlignment('bottom-left')
      scalebar.setAlignment('bottom-left')

      this.ui = ui
      // eslint-disable-next-line no-undef
      this.group = new H.map.Group()

      window.addEventListener('resize', () => this.map.getViewPort().resize())
    },
    methods: {
      onChange (e) {
        // const selected = e.sender.select().map(item => item.innerText)
        // console.log(selected('idGeraet'))
        this.overlay = true
        this.visible = true
        const tempGroup = this.group
        const tempui = this.ui
        try {
          const items = tempui.getBubbles()
          for (let i = 0; i < items.length; i++) {
            tempui.removeBubble(items[i])
          }
        } catch (e) {
          console.log(e)
        }

        try {
          this.group.removeAll()
        } catch (e) {
          console.log(e)
        }
        const items = e.sender.select()
        this.id = parseInt(items[0].children[0].innerText)
        // const tempMap = this.map

        // const tempMap = this.map
        console.log(tempGroup)
        this.group.addEventListener('tap', function (evt) {
          console.log(evt.target.getData())
          try {
            const items = tempui.getBubbles()
            for (let i = 0; i < items.length; i++) {
              tempui.removeBubble(items[i])
            }
          } catch (e) {
            console.log(e)
          }

          // eslint-disable-next-line no-undef
          const bubble = new H.ui.InfoBubble(evt.target.getPosition(), {
            content: evt.target.getData().toString(),
          })
          tempui.addBubble(bubble)
        })

        // eslint-disable-next-line no-undef
        const icon = new H.map.Icon(svg.GetGreyMarkerSvg())
        // eslint-disable-next-line no-undef
        const iconHalt = new H.map.Icon(svg.GetGreenMarkerSvg())
        this.coords = { lat: 47.2, lng: 8.1 }

        client.post(process.env.VUE_APP_API + '/device/trackeddevice', {
          Id: this.id,
          Von: this.vonDateString,
          Bis: this.bisDateString,
          DiffInMeters: parseInt(this.diffInMeters),
        }).then(response => {
          this.coordinateItems = response.data
          let len = parseInt((this.coordinateItems.length / 2), 10)
          let i = 0
          let n = 0
          let e = 0
          this.coordinateItems.forEach(function (item) {
            const coordinate = { lat: item.north, lng: item.east }

            n = n + item.north
            e = e + item.east

            // eslint-disable-next-line eqeqeq
            if (len - i <= 0) {
              len = 10000000
            }
            // eslint-disable-next-line eqeqeq
            if (item.state != null && item.state == 100) {
              // eslint-disable-next-line no-undef
              const markerHalt = new H.map.Marker(coordinate, { icon: iconHalt })
              markerHalt.setData(item.idDeviceTracking.toString() + '</br>' + item.displayTimestamp)
              tempGroup.addObject(markerHalt)
            } else {
              // eslint-disable-next-line no-undef
              const marker = new H.map.Marker(coordinate, { icon: icon })
              marker.setData(item.idDeviceTracking + '</br>' + item.displayTimestamp)
              tempGroup.addObject(marker)
            }
            i++
          })

          this.map.addObject(this.group)
          this.coords = { lat: n / i, lng: e / i }
          this.map.setCenter(this.coords)
          this.map.setZoom(8.5)
          this.overlay = false
        }).catch(error => {
          this.overlay = false
          console.log(error)
        })

        // this.showMarkers(this.map, this.coords)
        // const id = parseInt(items[0].children[0].innerText)
        // this.timestamp = format(new Date(), 'yyyy-MM-dd HH:mm:ss')
        // console.log(items)
        // console.log(items[0].innerText)
        // console.log(items[0].children[0].innerText)
        // this.$emit('rowChanged', items[0].children[0].innerText)
      },
      getDevices () {
        this.visible = false
        this.overlay = true
        client.post(process.env.VUE_APP_API + '/device/trackeddevices', {
          Von: this.vonDateString,
          Bis: this.bisDateString,
        }).then(response => {
          this.deviceItems = response.data
          this.overlay = false
        }).catch(error => {
          this.overlay = false
          console.log(error)
        })
      },
      capture (resultContainer, map, ui) {
        if (this.id === 0) {
          this.infoMessage = 'Bitte wählen Sie ein Fahrzeug aus !'
          this.info = true
          return
        }

        this.overlay = true
        map.capture(canvas => {
          if (canvas) {
            resultContainer.innerHTML = ''
            resultContainer.appendChild(canvas)
            const dataURL = canvas.toDataURL()
            client.post(process.env.VUE_APP_API + '/device/printdevice', {
              Id: this.id,
              Von: this.vonDateString,
              Bis: this.bisDateString,
              PrintTable: this.printTable,
              PrintMap: this.printGrafic,
              Base64Image: dataURL,
            }).then(response => {
              console.log(response.data)
              this.documentLink = response.data
              this.overlay = false
            }).catch(error => {
              this.overlay = false
              console.log(error)
            })
            // data:image/png;base64,
          } else {
            resultContainer.innerHTML = 'Capturing is not supported'
          }
        }, [ui])
      },
      snapshot () {
        const captureContainer = document.getElementById('panel')
        this.capture(captureContainer, this.map, this.ui)
      },
    },
  }
</script>
<style lang="scss" scoped>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }
    .capture-panel{
      display: inline-block;
      width: 100%;
      height: 835px;
      border: 1px solid red;
    }
    .checkbox-align {
      margin: 0px;
      padding: 0px;
    }
</style>
